import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { createAppError } from '@/utils/createAppError';
import posthog from 'posthog-js';
import { POSTHOG_EVENT } from '@/services/posthog/events';
import { alertError } from '../../../utils/alertError';

export async function logout() {
  try {
    posthog.capture(POSTHOG_EVENT.LOGOUT);
    await signOut(auth);
  } catch (error: any) {
    const message = error.message;
    const appError = createAppError(
      'unknown',
      'Failed to log out with Firebase. Firebase Error Message: ' + message,
    );
    alertError(appError);
  }
}
